module.exports = __webpack_public_path__ + "static/media/captain-america.1b4ee258.png";